type StockStatusKeys =
    | 'available'
    | 'availableInFuture'
    | 'onDemand'
    | 'unknown'
    | 'noLongerAvailable'
    | 'cannotBeOrderedInDesiredBranch'
    | 'unavailable'
    | 'notInStock'
    | 'notAvailableForPreorder'
    | 'restrictedForOrder';

export const primaryStockMessageKey: {
    [key in StockStatusKeys]: string;
} = {
    available: '{quantity} in stock',
    availableInFuture: '{quantity} available on {date}',
    onDemand: 'we order ex works for you!',
    noLongerAvailable: 'no longer available',
    unavailable: 'notApplicable',
    cannotBeOrderedInDesiredBranch: 'cannotBeOrderedInDesiredBranch',
    notInStock: 'notInStock',
    unknown: 'delivery date in verification',
    notAvailableForPreorder: 'not available for preorder',
    restrictedForOrder: 'restricted for order',
};

export const secondaryStockMessageKey: {
    [key in StockStatusKeys]?: string;
} = {
    availableInFuture: 'more available on {date}',
    onDemand: 'we will order more for you ex works!',
    noLongerAvailable: 'more no longer available',
    unavailable: 'notApplicable',
    cannotBeOrderedInDesiredBranch: 'cannotBeOrderedInDesiredBranch',
    notInStock: 'more notInStock',
    unknown: 'for further, delivery date in verification',
    notAvailableForPreorder: 'not available for preorder',
};

export const singleStockMessageKey: {
    [key in StockStatusKeys]: string;
} = {
    available: 'in stock',
    availableInFuture: 'available at future date',
    onDemand: 'we order ex works for you!',
    noLongerAvailable: 'no longer available',
    unavailable: 'notApplicable',
    cannotBeOrderedInDesiredBranch: 'cannotBeOrderedInDesiredBranch',
    notInStock: 'notInStock',
    unknown: 'delivery date in verification',
    notAvailableForPreorder: 'not available for preorder',
    restrictedForOrder: 'restricted for order',
};

export const mixedStockMessageKey: {
    [key in StockStatusKeys]: string;
} = {
    available: 'limited stock',
    availableInFuture: 'limited availability',
    onDemand: 'we order ex works for you!',
    noLongerAvailable: 'no longer available',
    unavailable: 'notApplicable',
    cannotBeOrderedInDesiredBranch: 'cannotBeOrderedInDesiredBranch',
    notInStock: 'notInStock',
    unknown: 'delivery date in verification',
    notAvailableForPreorder: 'not available for preorder',
    restrictedForOrder: 'some restricted for order',
};
